

(function($) {
	
	

/*
*  render_map
*
*  This function will render a Google Map onto the selected jQuery element
*
*  @type	function
*  @date	8/11/2013
*  @since	4.3.0
*
*  @param	$el (jQuery element)
*  @return	n/a
*/

function render_map( $el ) {

	// var
	var markers = $el.find('.marker');
	var zoom = $el.data('zoom');

	var customStyle = phpVars.googleMapStyle;

	if (typeof $el.data('no-map-style') !== 'undefined') {
		customStyle = false;
	}

	var customMarker = $el.data('custom-generic-marker');
	var markerIcon = customMarker ? customMarker : phpVars.googleMapsCustomMarker;
	var offsetMap = $el.data('offset-map');
	var mapWidth = $el.width();
	var xOffset =  mapWidth / 4;
	
	
	
	// vars
	var args = {
		zoom		: zoom,
		center		: new google.maps.LatLng(0, 0),
		streetViewControl: false,
		mapTypeControl: false,
		mapTypeControlOptions: {
		  mapTypeIds: [google.maps.MapTypeId.ROADMAP, 'map_style']
		},
		zoomControl: true,
		zoomControlOptions: {
		  style: google.maps.ZoomControlStyle.SMALL
		},
		scrollwheel: false
	};
	
	
	// create map	        	
	var map = new google.maps.Map( $el[0], args);


	// Offset map position
	if (offsetMap === 'left') {

		map.panBy(xOffset,0);

	} else if (offsetMap === 'right') {

		map.panBy(-xOffset,0);

	}

	
	
	
	if (customStyle) {
		var styles = JSON.parse(customStyle);
		var styledMap = new google.maps.StyledMapType(styles,{name: "Dark"});
		
		map.mapTypes.set('map_style', styledMap);
  		map.setMapTypeId('map_style');
	}
	
	
	
	

	// add a markers reference
	map.markers = [];

	// add markers
	markers.each(function(){

    	add_marker( $(this), map, markerIcon );

	});

	// center map
	center_map( map );
	
	

}

/*
*  add_marker
*
*  This function will add a marker to the selected Google Map
*
*  @type	function
*  @date	8/11/2013
*  @since	4.3.0
*
*  @param	$marker (jQuery element)
*  @param	map (Google Map object)
*  @return	n/a
*/

function add_marker( $marker, map, markerIcon ) {

	// var
	var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );
	var customMarker = $marker.data('custom-marker');
	customMarker = customMarker ? customMarker : markerIcon;
	var pixelOffset = false;
	
	
	var markerOptions = {
		position	: latlng,
		map			: map
	}
	 
	if (customMarker) {

		var icon = {
			 url : customMarker,
			 size: new google.maps.Size(120, 120), // size
			 scaledSize: new google.maps.Size(60,60),
			 origin: new google.maps.Point(0,0), // origin
			 anchor: new google.maps.Point(30, 60) // anchor 
		 };
		 
		 markerOptions.icon = icon;
		 pixelOffset = new google.maps.Size(-30, 0);
	}
	
	 
	// create marker
	var marker = new google.maps.Marker( markerOptions );

	// add to array
	map.markers.push( marker );

	// if marker contains HTML, add it to an infoWindow
	if( $marker.html() )
	{
		// create info window
		var infowindow = new google.maps.InfoWindow({
			content		: $marker.html(),
			pixelOffset : pixelOffset
		});

		// show info window when marker is clicked
		google.maps.event.addListener(marker, 'click', function() {

			infowindow.open( map, marker );

		});
	}

}

/*
*  center_map
*
*  This function will center the map, showing all markers attached to this map
*
*  @type	function
*  @date	8/11/2013
*  @since	4.3.0
*
*  @param	map (Google Map object)
*  @return	n/a
*/

function center_map( map ) {

	// vars
	var bounds = new google.maps.LatLngBounds();

	// loop through all markers and create bounds
	$.each( map.markers, function( i, marker ){

		var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

		bounds.extend( latlng );

	});

	// only 1 marker?
	if( map.markers.length == 1 )
	{
		// set center of map
	    map.setCenter( bounds.getCenter() );
	}
	else
	{
		// fit to bounds
		map.fitBounds( bounds );
	}

}

/*
*  document ready
*
*  This function will render each map when the document is ready (page has loaded)
*
*  @type	function
*  @date	8/11/2013
*  @since	5.0.0
*
*  @param	n/a
*  @return	n/a
*/

window.jrRenderMaps = function jrRenderMaps() {

	$('.google-map.js .map').each(function(){

		render_map( $(this) );

	});

};

})(jQuery);